import { dataFetcher } from 'core/services/requestHandler';   

const getSeatSharingInfo   = async (data = {}, config = {}) => {
  return dataFetcher('operations/seatSharingInfo', data, {...config});
};

const getSharedSeats = async (data = {}, config = {}) => {
  return dataFetcher('operations/sharedSeats', data, {...config});
};

const subscribeToSeatSharing = async (data = {}, config = {}) => {
  return dataFetcher('operations/subscribeToSeatSharing', data, {...config});
};

const saveSharedSeats = async (data = {}, config = {}, path) => {
  return dataFetcher(`operations/saveSharedSeats/${path}`, data, {method: 'POST',...config});
};

export {getSeatSharingInfo, getSharedSeats, subscribeToSeatSharing, saveSharedSeats}
